import React from 'react';
import { Box, Text, HStack } from '@chakra-ui/react';
import { ReactComponent as AlertIcon } from '../../assets/images/icons/mevo/alert.svg';

interface IncompletePrescriptionsAlertProps {
  count: number;
}

export const IncompletePrescriptionsAlert: React.FC<IncompletePrescriptionsAlertProps> = ({ count }) => {
  return (
    <Box
      bg="#FEF2F2"
      border="1px solid #FECACA"
      borderRadius="8px"
      p="12px 16px"
      mb="16px"
      mt="24px"
      display="flex"
      alignItems="center"
      gap="8px"
    >
      <HStack spacing="8px" align="center" flex="1">
        <Box color="#DC2626" display="flex" alignItems="center">
          <AlertIcon width="16px" height="16px" />
        </Box>
        <Text fontSize="14px" fontWeight="500" color="#DC2626" lineHeight="20px">
          Existem prescrições incompletas, verifique a lista e edite para continuar
        </Text>
      </HStack>
    </Box>
  );
};
